<ng-container *ngIf="moduleManager.settingsView === cxOne && initialized">
    <div class="form-group" cvModuleCxoneCustomSettingSection after="rec" [moduleManager]="moduleManager">
        <!-- Evaluator Performance Additional Filters -->
        <p class="cxone-section-header" cvLocalizedText langSection="CXOne_Modal" langKey="Additional_Filters">Additional Filters</p>
        <cv-date-paradigm-filter [selectedMetrics]="selectedMetrics" [moduleManager]="moduleManager"></cv-date-paradigm-filter>
        <cv-metric-dynamic-filters [selectedMetrics]="selectedMetrics" [moduleManager]="moduleManager"></cv-metric-dynamic-filters>

        <!-- Evaluator Performance Thresholds -->
        <div class="cxone-settings-title" style="margin-top: 20px;" cvLocalizedText langSection="Evaluator_Performance" langKey="Evaluator_Title">EVALUATOR PERFORMANCE THRESHOLDS</div>

        <!-- Evaluator Performance Scale -->
        <div class="cxone-settings-subtitle" style="margin-top: 20px; margin-bottom: -15px;" cvLocalizedText langSection="Evaluator_Performance" langKey="Completed_Threshold">COMPLETED THRESHOLD</div>
        <br>
        <cxone-range-slider
            [(ngModel)]="rangeSlider"
            [max]="100"
            [min]="0"
            [step]="1"
            [markerValues]="11"
            [startPoints]="[60, 90]"
            [connect]="[true, true, true]"
            [colorClasses]="['cxone-red', 'cxone-grey', 'cxone-blue']"
            [enableTooltipOnDrag]="true"
            [markerSuffix]="'%'">
        </cxone-range-slider>

        <!-- Appealed Scale -->
        <div class="cxone-settings-subtitle" style="margin-top: 60px; margin-bottom: 10px;" cvLocalizedText langSection="Evaluator_Performance" langKey="Appealed_Threshold">APPEALED THRESHOLD</div>
        <div class="container">
            <div class="row">
                <div class="red-subtitle" cvLocalizedText langSection="Evaluator_Performance" langKey="Show_As_Red">Show as red above</div>
                <cxone-numeric-selector
                    [(ngModel)]="appealedScaleValue"
                    [step]="1"
                    [min]="0"
                    [max]="100">
                </cxone-numeric-selector>
                <div class="mt-2 ml-2">%</div>
            </div>
        </div>
        <br>
    </div>
</ng-container>
